<template>
  <div>
    <stepper :options="options" v-model="step">
      <div slot="step-0">
        <uform>
          <ulabel size="12">
            <uinput
              placeholder="Full Name (will be used in cerificate)*"
              v-model="model.name"
              suggest="eg. Sabit Hossain"
            ></uinput>
          </ulabel>
          <ulabel size="6">
            <uinput
              placeholder="Phone*"
              v-model="model.phone"
              suggest="eg. 01712345678"
            ></uinput>
          </ulabel>
          <ulabel size="6">
            <uinput
              placeholder="Email*"
              v-model="model.email"
              suggest="Must be a valid email"
            ></uinput>
          </ulabel>
          <ulabel size="6">
            <uinput
              placeholder="LinkedIn URL*"
              suggest="Must be a valid LinkedIn profile"
              v-model="model.linkedin"
            ></uinput>
          </ulabel>
          <ulabel size="6">
            <uinput
              placeholder="Occupation*"
              suggest="eg. Software Engineer"
              v-model="model.occupation"
            ></uinput>
          </ulabel>
          <ulabel size="6">
            <uinput
              placeholder="Industry"
              v-model="model.industry"
              suggest="eg. Information Technology"
            ></uinput>
          </ulabel>
          <ulabel size="6">
            <uinput
              placeholder="Location"
              v-model="model.location"
              suggest="eg. Dhanmondi"
            ></uinput>
          </ulabel>
          <ulabel size="6">
            <uinput
              placeholder="Password*"
              v-model="model.password"
              type="password"
              suggest="At least 8 characters preferred"
            ></uinput>
          </ulabel>
          <ulabel size="6">
            <uinput
              placeholder="Confirm Password*"
              v-model="confirmPassword"
              type="password"
              suggest="Re-type the password"
            ></uinput>
          </ulabel>
          <ubtn @click.prevent.native="next" :loading="loading">Next</ubtn>
        </uform>
        <p class="waring">* Compulsory Fields</p>
      </div>
      <div slot="step-1">
        <uselect v-model="model.other.attendant" :items="reasons"></uselect>
        <ubtn @click.prevent.native="next" :loading="loading">Next</ubtn>
        <ubtn @click.prevent.native="prev" mode="outline" :loading="loading"
          >Previous</ubtn
        >
      </div>
      <div slot="step-2">
        <uselect v-model="model.other.interests" :items="interests"></uselect>
        <ubtn @click.prevent.native="next" :loading="loading">Next</ubtn>
        <ubtn @click.prevent.native="prev" mode="outline" :loading="loading"
          >Previous</ubtn
        >
      </div>
      <div slot="step-3">
        <uselect v-model="model.other.referrer" :items="referral"></uselect>
        <ubtn @click.prevent.native="next" :loading="loading">Next</ubtn>
        <ubtn @click.prevent.native="prev" mode="outline" :loading="loading"
          >Previous</ubtn
        >
      </div>
      <div slot="step-4">
        <div class="cr_terms">
          <ol>
            <li>
              UPSKILL will make any Offer in email communication or notification
              via its platform
            </li>
            <li>
              The Offer contains a description of the Training and / or material
              that is part of the Training.
            </li>
            <li>
              The Offer shall in any case at least state the following
              information in a clear manner:
              <ul
                style="margin-left: 30px; margin-top: 5px; margin-bottom: 5px;"
              >
                <li>set-up of the Training</li>
                <li>the proposed agenda for the Training</li>
                <li>the duration of the Training</li>
                <li>the Price including all additional costs and taxes</li>
                <li>
                  the applicability of these Terms and Conditions including at
                  the hyperlink
                </li>
              </ul>
            </li>
            <li>
              These General Terms and Conditions are explicitly referred to in
              the offer to the user prior to the Agreement and are an integral
              part of the general information provided by UPSKILL
            </li>
            <li>
              After registration the user will be required to make the payment
              within 24 hours. Delay or Non payment may result in losing the
              registered spot for the session and Upskill will not be liable for
              the loss of spot.
            </li>
            <li>
              By accepting all the conditions customer will abide by these
              contract
            </li>
          </ol>
        </div>
        <ubtn @click.prevent.native="accept" :loading="loading">Accept</ubtn>
        <ubtn @click.prevent.native="prev" mode="outline" :loading="loading"
          >Previous</ubtn
        >
      </div>
    </stepper>
  </div>
</template>

<script>
import Stepper from "../components/Stepper";
export default {
  name: "User Register",
  components: {
    Stepper
  },
  data() {
    return {
      loading: false,
      step: 0,
      selected: "",
      confirmPassword: "",
      model: { other: {} },
      options: {
        headers: [
          {
            title: "Help us build a Personalised Experience for you",
            subtitle: "Please provide details about yourself",
            img: require("../assets/images/registration-01.png")
          },
          {
            title: "Why would you like to attend our workshops?",
            subtitle: "(Pick multiple categories if applicable)",
            img: require("../assets/images/why_attend.png")
          },
          {
            title: "What are your areas of expertise?",
            subtitle: "(Pick multiple categories if applicable)",
            img: require("../assets/images/registration-02.png")
          },
          {
            title: "How did you hear about Upskill?",
            subtitle: "(Pick multiple categories if applicable)",
            img: require("../assets/images/registration-03.png")
          },
          {
            title: "Terms & Condition",
            subtitle:
              "By clicking accept you agree to the terms and conditions",
            img: require("../assets/images/registration-06.png")
          }
        ]
      },
      interests: [
        "Digital Marketing",
        "Business",
        "Coding / Programming",
        "Art And Design",
        "Data Analytics",
        "Others"
      ],
      reasons: [
        "Develop my skills",
        "Get my first job",
        "Increase my earning",
        "Change my career",
        "To learn from experts",
        "Other"
      ],
      referral: [
        "Facebook",
        "LinkedIn",
        "Google Search",
        "Friend/Family",
        "Event/News",
        "Article/Blog",
        "Other"
      ]
    };
  },
  methods: {
    next() {
      // Case X = Step X
      switch (this.step) {
        case 0:
          // Required
          if (
            !this.model.name ||
            !this.model.email ||
            !this.model.phone ||
            !this.model.linkedin ||
            !this.model.occupation
          ) {
            this.ErrorAlert(this.$errors.REQUIRED_FIELDS);
            break;
          }
          // Password match
          if (this.model.password !== this.confirmPassword) {
            this.ErrorAlert(this.$errors.PASSWORD_NO_MATCH);
            break;
          }
          // Password short
          if (this.model.password.length < 8) {
            this.ErrorAlert(this.$errors.PASSWORD_SHORT);
            break;
          }
          // Validate from backend
          this.loading = true;
          this.$upskill
            .validate({ email: this.model.email, phone: this.model.phone })
            .then(() => {
              this.step++;
              this.loading = false;
            })
            .catch(err => {
              let errString = "";
              if (err.response.data.errors) {
                Object.keys(err.response.data.errors).forEach(k => {
                  errString += err.response.data.errors[k];
                });
              }
              this.ErrorAlert(err.response.data.message + errString);
              this.loading = false;
            });
          break;
        case 1:
          if (
            !this.model.other.attendant ||
            this.model.other.attendant.length < 1
          ) {
            this.ErrorAlert(this.$errors.MIN_ONE_OPTION);
            break;
          } else {
            this.step++;
          }
          break;
        case 2:
          if (
            !this.model.other.interests ||
            this.model.other.interests.length < 1
          ) {
            this.ErrorAlert(this.$errors.MIN_ONE_OPTION);
            break;
          } else {
            this.step++;
          }
          break;
        case 3:
          if (
            !this.model.other.referrer ||
            this.model.other.referrer.length < 1
          ) {
            this.ErrorAlert(this.$errors.MIN_ONE_OPTION);
            break;
          } else {
            this.step++;
          }
          break;
      }
    },
    prev() {
      this.step--;
    },
    accept() {
      this.loading = true;
      let validResponse = false;
      this.$upskill
        .registerUser(this.model)
        .then(res => {
          validResponse = true;
          this.loading = false;
          this.SuccessAlert(res.data.message);
          this.localStorage.setItem("token", res.data.token);
          let pw = this.PendingWorkshop();
          if (pw) {
            this.localStorage.removeItem("pendingWorkshop");
            this.GotoWS(pw);
          } else {
            this.Goto({ name: "home" });
          }
        })
        .catch(() => {
          this.loading = false;
          if (!validResponse) {
            this.ErrorAlert(
              "Something went wrong! Please contact our support."
            );
          }
        });
    }
  },
  computed: {},
  created() {
    this.Loaded();
  }
};
</script>

<style scoped></style>
